export default __webpack_public_path__ + "static/media/icon-plugin2.0505edab.svg";